module.exports = __webpack_public_path__ + "media/images/products/banners/investimento_global-eed93d261178d646f7ff50211dd86cd7.png";